import { UNIFIED_ICONS, DEFAULT_UNIFIED_ICON, UnifiedIcon } from '../config/unifiedIcons';

/**
 * Vérifie si une catégorie existe dans la nouvelle configuration
 */
export const categoryExists = (categoryName: string): boolean => {
  return categoryName in UNIFIED_ICONS;
};

/**
 * Obtient l'icône unifiée pour une catégorie donnée
 * Retourne l'icône par défaut si la catégorie n'existe pas
 */
export const getIconForCategory = (categoryName: string): UnifiedIcon => {
  if (!categoryName) return DEFAULT_UNIFIED_ICON;
  return UNIFIED_ICONS[categoryName] || DEFAULT_UNIFIED_ICON;
};

/**
 * Obtient le nom Font Awesome pour une catégorie
 * Utilisé pour la rétrocompatibilité avec les marqueurs existants
 */
export const getFontAwesomeNameForCategory = (categoryName: string): string => {
  const icon = getIconForCategory(categoryName);
  return icon.faName;
};

/**
 * Obtient le composant React Icon pour une catégorie
 * Utilisé pour la sidebar et autres composants React
 */
export const getReactIconForCategory = (categoryName: string) => {
  const icon = getIconForCategory(categoryName);
  return icon.component;
};

